import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Button, Modal, ProgressBar } from 'react-bootstrap';
import { Icon } from "react-icons-kit";
import {ic_check_circle} from 'react-icons-kit/md/ic_check_circle';
import * as CheckMark from "../../lottie-gif/checkmark-animation.json";
import Lottie from 'react-lottie';
import {close} from 'react-icons-kit/ikons/close';

class UserProfileNavLink extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showProfileCompleteModal: false,
        };
    }
    
    componentDidMount() {
        // Check conditions and show the modal
        this.checkProfileCompletion();

    }
    
    componentDidUpdate(prevProps) {
        // Check conditions and show the modal when props change
        if (prevProps.freelancerProfile.profileCompletedPercentage !== this.props.freelancerProfile.profileCompletedPercentage) {
            this.checkProfileCompletion();
        }
    }
    
    checkProfileCompletion() {
        const { profileCompletedPercentage } = this.props.freelancerProfile;
        const { isProfileCompleted } = this.props?.freelancerProfile || {};
        const alreadyShown = localStorage.getItem(`profileCompletedModalShown-${this?.props?.auth?.user?._id}`);
      
        if (profileCompletedPercentage === 100 && !isProfileCompleted && !alreadyShown) {
            // Show the modal
            this.setState({ showProfileCompleteModal: true });
            localStorage.setItem(`profileCompletedModalShown-${this?.props?.auth?.user?._id}`, true);
        }
    }

    handleCloseModal = () => {
        // Close the modal
        this.setState({ showProfileCompleteModal: false });
    };

    

    render() {
        const userType = this.props?.auth?.user?.type;
        const expertProfileCompletedPercentage = this.props?.freelancerProfile?.profileCompletedPercentage;
        const expertProfileCompletedItems = this.props?.freelancerProfile?.profileCompletedItems;
        let NavLinksItem;
        
        if (userType == "Freelancer") {
            NavLinksItem = (
                <>
                    <p className=''><span>Complete these fields to explore the more expert options</span></p>
                    <div className="dropdown-menu-show bg-white rounded shadow-sm mt-2">
                            <>  
                                <div className=''>
                                    <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/expertise">Expertise {expertProfileCompletedItems?.expertise && <Icon icon={ic_check_circle} />}</NavLink>
                                    <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/expertiselevel">Expertise Level {expertProfileCompletedItems?.expertLevel && <Icon icon={ic_check_circle} />}</NavLink>
                                    <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/languages">Languages {expertProfileCompletedItems?.languageVal && <Icon icon={ic_check_circle} />}</NavLink>
                                    <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/hourlyrate">Hourly Rate {expertProfileCompletedItems?.hourlyRate && <Icon icon={ic_check_circle} />}</NavLink>
                                    <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/titleandoverview">Title & Overview {expertProfileCompletedItems?.TitleAndOverview && <Icon icon={ic_check_circle} />}</NavLink>
                                    <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/profileandphoto">Profile & Photo {expertProfileCompletedItems?.profileAndPhoto && <Icon icon={ic_check_circle} />}</NavLink>
                                    {/* <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/location">Location {expertProfileCompletedItems?.Location && <Icon icon={ic_check_circle} />}</NavLink> */}
                                </div>
                                {/* <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/phone">Verification {expertProfileCompletedItems?.freelancerprofile && <Icon icon={ic_check_circle} />}</NavLink> */}
                            </>
                    </div>
                   <p className='mt-4'>Complete these fields to get verified</p>
                    <div className="dropdown-menu-show bg-white rounded shadow-sm mt-2">
                        <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/education">Education {expertProfileCompletedItems?.education && <Icon icon={ic_check_circle} />}</NavLink>
                        <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/certificate">Certificate {expertProfileCompletedItems?.certification && <Icon icon={ic_check_circle} />}</NavLink>
                        <NavLink className="dropdown-item py-2 d-flex justify-content-between" activeClassName="active" to="/employment">Employment {expertProfileCompletedItems?.employment && <Icon icon={ic_check_circle} />}</NavLink>
                    </div>
                </>
              )
        } else {
            NavLinksItem = (
                <div className="dropdown-menu-show">
                    {/*<NavLink className="dropdown-item py-2" activeClassName="active" to="/headline">Headline</NavLink>
                    <NavLink className="dropdown-item py-2" activeClassName="active" to="/skills">Skills</NavLink>
                    <NavLink className="dropdown-item py-2" activeClassName="active" to="/scope">Scope</NavLink>
                    <NavLink className="dropdown-item py-2" activeClassName="active" to="/budget">Budget</NavLink>*/}
                    {/* <NavLink className="dropdown-item py-2" activeClassName="active" to="/postjobclient">Post Job</NavLink> */}
                    <NavLink className="dropdown-item py-2" activeClassName="active" to="/clientcompleteprofile">Profile</NavLink>
                    
                </div>
            );
        }

        const UserCompleteprofileModal = (
            <>
                <Modal onBackdropClick={this.handleCloseModal} className='px-5 py-5' size='md' show={this.state.showProfileCompleteModal} centered>
                    <Modal.Body>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div style={{flex:'1'}}>
                                <h3 className='text-center'>Profile Completed</h3>
                            </div>
                            <div  className="mb-2" style={{backgroundColor: 'transaprent', boxShadow: 'none', cursor:'pointer'}}  onClick={this.handleCloseModal}><Icon size={32} icon={close} /></div>
                        </div>
                        <Lottie 
                            options={{
                                loop: false,
                                autoplay: true,
                                animationData: CheckMark,
                                rendererSettings: {
                                    preserveAspectRatio: "xMidYMid slice"
                                },
                            }}
                            height={180}
                            width={180}
                        />
                        <div className='text-center'><p style={{fontSize:'17px'}}>Thanks for completing the profile, Your profile is submitted for verification!</p></div>
                    </Modal.Body>
                </Modal>
            </>
        )


        return(
            <div>
                {UserCompleteprofileModal}
                <div className="overflow-hidden sidebar-fix mb-3">
                    {NavLinksItem}
                </div>
                {userType === "Freelancer" && 
                    <div className="d-flex align-items-center py-2 px-3 bg-white rounded shadow-sm">
                        {/* {!pageLoaded? (
                        <Skeleton width={100} height={18} />
                        ) : ( */}
                        <span>Profile Completed</span>
                        {/* )} */}
                        <div className="font-weight-bold ml-auto d-flex align-items-center " style={{width: "35%"}} >
                        <ProgressBar now={expertProfileCompletedPercentage} variant="success" className="w-100 " />
                        {/* <span className="btn btn-primary border-0 py-1 px-4 mr-2"></span>{" "} */}
                        {/* {!pageLoaded ? (
                            <Skeleton width={40} height={18} />
                        ) : 
                    } */}
                        <span className="ml-1">{expertProfileCompletedPercentage}%</span>
                        </div>
                    </div>
                 }
            </div>
        );
    }
}

const mapStateToProp = (state) => ({
   auth: state.auth,
   freelancerProfile: state.freelancerProfile,
});

export default connect(mapStateToProp)(UserProfileNavLink);